// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"e277c996","278":"7e419ce1","711":"496093aa","944":"ec7419b5","960":"2e276791","992":"bda846a9"}[chunkId] + ".chunk.css";
};